import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginScreen from './pages/LoginScreen';
import CadastrarModelo from './pages/CadastrarModelo';
import CadastrarCertificado from './pages/CadastrarCertificado';
import EmitirCertificado from './pages/EmitirCertificado';
import PerfilAluno from './pages/PerfilAluno';
import Certificado from './pages/Certificado';
import ListModelos from './pages/ListModelos';
import EditarModelo from './pages/EditarModelo';
import CadastroAdm from './pages/CadastroAdm';
import Usuarios from './pages/Usuarios';
import ListInstituicao from './pages/ListInstituicao';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/" />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LoginScreen />} />
          <Route
            path="/cadastrar-modelo"
            element={
              <PrivateRoute>
                <CadastrarModelo />
              </PrivateRoute>
            }
          />
          <Route
            path="/cadastrar-certificado"
            element={
              <PrivateRoute>
                <CadastrarCertificado />
              </PrivateRoute>
            }
          />
          <Route
            path="/emitir-certificado"
            element={
              <PrivateRoute>
                <EmitirCertificado />
              </PrivateRoute>
            }
          />
          <Route
            path="/list-modelo"
            element={
              <PrivateRoute>
                <ListModelos />
              </PrivateRoute>
            }
          />
          <Route
            path="/edit-modelo/:id_modelo"
            element={
              <PrivateRoute>
                <EditarModelo />
              </PrivateRoute>
            }
          />
          <Route
            path="/cadastro-adm"
            element={
              <PrivateRoute>
                <CadastroAdm />
              </PrivateRoute>
            }
          />
          <Route
            path="/usuarios-adm"
            element={
              <PrivateRoute>
                <Usuarios />
              </PrivateRoute>
            }
          />
          <Route
            path="/instituicao-adm"
            element={
              <PrivateRoute>
                <ListInstituicao />
              </PrivateRoute>
            }
          />
          <Route path="/qrcode/:certificadoId" element={<Certificado />} />
          <Route path="/perfil-aluno" element={<PerfilAluno />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
